import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Zone } from './Zone';
import { ZoneElementSelectorItems } from './ZoneElementSelectorItems';

const Frame = styled.div`
    display: flex;
    gap: .25rem;
    flex-direction: column;
    flex-wrap: wrap;
    width: 30rem;
    height: 15.5rem;
`;

type ZoneStyleWidgetValue = Pick<Zone, 'border' | 'headingOffset' | 'headingStyle' | 'headingPosition'>;
const ZoneStyleWidgetValue = ({ border, headingOffset, headingStyle, headingPosition }: ZoneStyleWidgetValue) =>
    ({ border, headingOffset, headingStyle, headingPosition }) as ZoneStyleWidgetValue;

export const ZoneStyleWidget = ({ widget }: { widget: PopoutWidget }) => {

    const items = ZoneElementSelectorItems(widget.color || Colors.primary);
    const initial = useMemo(() => widget.value, []);

    const onApply = (props: any, complete?: boolean) => {
        if (!props.titleColor) delete props.titleColor;
        widget.update({ value: ZoneStyleWidgetValue(props), open: !complete });
    };

    const onReset = () => onApply(initial);

    return <Flexer padding=".5">
        <Frame onMouseLeave={onReset}>
            {items.map(({ id, props, preview }) =>
                <DropButton padding=".25" overflow=".125" key={id} onMouseEnter={() => onApply(props)} onClick={() => onApply(props, true)}>
                    {React.createElement(preview.impl, props)}
                </DropButton>
            )}
        </Frame>
    </Flexer>;

    // private onSelect = (font: FontFamilyInfo) => () => {
    //     this.props.widget.update({
    //         open: false,
    //         value: font.name,
    //     });
    // };
};
